import { Activity } from "lucide-react";
import { fmtDate, fmtMoney, fmtNum } from "@/lib/api";
import { RangePicker, scopedSnapshot } from "@/lib/scope";

const Cell = ({ label, value, testid }) => (
  <div>
    <div className="cc-eyebrow">{label}</div>
    <div data-testid={testid} className="mt-1 font-mono text-lg font-bold text-slate-50">{value}</div>
  </div>
);

export default function SyncSummary({ snapshot, range, setRange }) {
  if (!snapshot) {
    return (
      <div data-testid="sync-summary-empty" className="cc-card am-rise mb-6 flex items-center gap-3 p-4 text-sm text-slate-400">
        <Activity className="h-4 w-4 text-slate-500" /> No sync yet. Use “Pull last 30 days” in the Performance panel below.
      </div>
    );
  }
  const cur = snapshot.account?.currency;
  const v = scopedSnapshot(snapshot, range);
  const t = v.totals;
  return (
    <div data-testid="sync-summary" className="cc-card am-rise mb-6 p-5" style={{ boxShadow: "inset 3px 0 0 #10b981" }}>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-slate-100"><Activity className="h-4 w-4 text-emerald-400" /> Last sync · {snapshot.account?.name}</div>
        <RangePicker range={range} setRange={setRange} testid="sync-range" />
        <div data-testid="sync-summary-time" className="font-mono text-xs text-slate-400">{fmtDate(snapshot.pulled_at)}</div>
      </div>
      <div className="mb-3 text-[11px] uppercase tracking-wider text-emerald-300/80" data-testid="sync-summary-scope">{v.scope}</div>
      <div className="grid grid-cols-2 gap-5 md:grid-cols-4 xl:grid-cols-8">
        <Cell label={`${v.scope} · Cost`} value={fmtMoney(t.cost, cur)} testid="sync-summary-cost" />
        <Cell label="Clicks" value={fmtNum(t.clicks)} testid="sync-summary-clicks" />
        <Cell label="Conversions" value={fmtNum(t.conversions)} testid="sync-summary-conversions" />
        <Cell label="Cost / conv." value={fmtMoney(t.cost_per_conversion, cur)} testid="sync-summary-cpa" />
        <Cell label="Campaigns" value={v.campaigns.length} testid="sync-summary-campaigns" />
        <Cell label="Ad groups" value={v.ad_groups.length} testid="sync-summary-adgroups" />
        <Cell label="Keywords" value={fmtNum(v.keywords.length)} testid="sync-summary-keywords" />
        <Cell label="Search terms" value={fmtNum(v.search_terms.length)} testid="sync-summary-search-terms" />
      </div>
    </div>
  );
}
